
if (!customElements.get('slide-custom')) {
  customElements.define(
    'slide-custom',
    class MediaGalleryGlide extends HTMLElement {
      constructor() {
        super();
        var second_image = document.querySelector(".second_slide img");       
        function imageLoaded() {
          document.querySelector(".first_slide").remove();
          const swiper = new Swiper('.index-swiper', {
            loop: true,
            spaceBetween: 0,
            slidesPerView: 1,
            pagination: {
              el: ".swiper-pagination",
              dynamicBullets: false,
            },
            autoplay: {
              delay: 2500,
              disableOnInteraction: false,
            },
          })
        }
        if (second_image.complete) {
          imageLoaded()
        } else {
          second_image.addEventListener('load', imageLoaded)
        }
      }
    }
  );
}
